import { Info } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/motion";
import { SectionLabel, PageHero, CtaSection } from "../components/common";
import { PROJECTS } from "../data/site";

export default function Projects() {
  return (
    <>
      <Seo
        title="Projects | STERILTRON International References"
        description="Explore representative STERILTRON projects across hospitals, healthcare networks, industrial facilities and public-sector programmes worldwide."
        path="/projects"
      />
      <PageHero
        label="Projects"
        titleLines={["Delivered Across", "Continents"]}
        description="Representative STERILTRON deployments spanning hospitals, treatment facilities and industrial plants — engineered, installed and supported worldwide."
      />

      <section className="py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div data-testid="projects-disclaimer" className="flex items-start gap-3 bg-brand-50 border border-brand-200 p-5 text-sm text-brand-900">
            <Info size={18} className="flex-shrink-0 mt-0.5 text-brand-700" />
            <p>The projects shown below are illustrative demo/placeholder references presented for layout purposes. They will be replaced with verified STERILTRON project information.</p>
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={(i % 2) * 0.08}>
              <article className="group bg-white border border-slate-200 hover:border-brand-800 transition-colors h-full">
                <div className="overflow-hidden relative">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-64 md:h-72 object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1.5 text-[11px] font-semibold uppercase tracking-widest text-brand-800">Demo</span>
                </div>
                <div className="p-8">
                  <div className="flex flex-wrap items-center gap-3 text-xs uppercase tracking-widest">
                    <span className="text-brand-700 font-semibold">{p.region}</span>
                    <span className="text-slate-300">/</span>
                    <span className="text-slate-500">{p.category}</span>
                  </div>
                  <h2 className="mt-4 font-heading text-xl md:text-2xl font-semibold tracking-tight text-brand-950">{p.title}</h2>
                  <p className="mt-3 text-slate-600 leading-relaxed">{p.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaSection />
    </>
  );
}
